// ********************************************************
// Logger utillity
// Log tool for the client.
// ********************************************************

// todo: consider logging somehow else on the client
export function log (...args) {
  // eslint-disable-next-line no-console
  console.log(...args)
}
